import { cn } from '../../utils/cn';

/**
 * The standard page header: title, one-line purpose, actions on the right.
 *
 * Every list page hand-rolled this same block with slightly different
 * spacing and heading sizes (text-2xl vs text-3xl, mb-4 vs mb-6). One
 * component keeps the hierarchy identical everywhere and gives remodels a
 * single place to evolve it (breadcrumbs, tabs) later.
 */
export function PageHeader({ title, description, actions, children, className }) {
	return (
		<div className={cn('mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between', className)}>
			<div className="min-w-0">
				<h1 className="text-2xl sm:text-3xl font-semibold text-foreground truncate">{title}</h1>
				{description && <p className="mt-1 text-sm sm:text-base text-muted-foreground">{description}</p>}
				{children}
			</div>
			{actions && <div className="flex items-center gap-3 shrink-0">{actions}</div>}
		</div>
	);
}

export default PageHeader;
